export const Breakpoints = {
  med: "817px",
  large: "1440px"
};
